import request from '@/utils/request'

// 获取全部相册列表
export function getAlbumList (params) {
  return request({
    url: '/Album/listAll',
    method: 'get',
    params: params
  })
}

// 创建相册
export function createAlbum (data) {
  return request({
    url: '/Album/create',
    method: 'post',
    data: data
  })
}

// 更新相册
export function updateAlbum (id, data) {
  return request({
    url: '/Album/update/' + id,
    method: 'post',
    data: data
  })
}

// 删除相册
export function deleteAlbum (data) {
  return request({
    url: '/Album/delete',
    method: 'post',
    params: data
  })
}

// 获取相册图片列表
export function getAlbumPicAll (params) {
  return request({
    url: '/Album/listPicAll',
    method: 'get',
    params: params
  })
}

// 添加相册图片
export function createAlbumPic (data) {
  return request({
    url: '/Album/createAlbumPic',
    method: 'post',
    data: data
  })
}

// 删除图片
export function deleteAlbumPic (data) {
  return request({
    url: '/Album/deleteAlbumPic',
    method: 'get',
    params: data
  })
}

// 转移相册
export function changePicAlbum (data) {
  return request({
    url: '/Album/updateMoveAlbum',
    method: 'post',
    params: data
  })
}







// WEBPACK FOOTER //
// ./src/api/productAlbum.js